import React, {useCallback} from "react";
import {downloadAPIFile} from "../../api/useFetch";
import {DropZone} from "../common/DropZone";
import {getCurrentUser} from "../CommonFunctions";


export const ProjectFiles = (props) => {

    const {project, successCallback, errorCallback} = props;

    const onFileUploaded = useCallback((response) => {
        successCallback('Les fichiers ont été ajoutés au projet.');
    }, []);

    const onFileNotUploaded = useCallback((response) => {
        errorCallback('Une erreur est survenue.');
    }, []);

    const createRequestBody = useCallback((file, containerData) => {
        return {
            user: process.env.REACT_APP_API_URI + `users/${getCurrentUser().id}`,
            name: file.name,
            size: file.size,
            project: process.env.REACT_APP_API_URI + `projects/${containerData.id}`
        };
    }, []);

    return (
        <>
            <div id="project__pieces" className="block">
                <h2>Pièces dans le projet</h2>

                <div id="pieces__listing">
                    {
                        project.pieces_in_project.length > 0 ?
                            project.pieces_in_project.map(piece_in_project => (
                                <div className="listing__piece-item" key={piece_in_project.id}>
                                    <a href="#">
                                        <div className="piece__name">{piece_in_project.piece.name}</div>
                                        <p className="piece__quantity">x{piece_in_project.copies}</p>
                                    </a>
                                </div>
                            ))
                            : <em>Aucune pièce dans le projet</em>
                    }
                </div>
            </div>
            <div id="project__files" className="block">
                <h2>Fichiers attachés au projet ({project.attached_files.length} fichier(s))</h2>

                <div id="files__list">
                    {project.attached_files.map((file) => (
                        <a href="#" className="files-list__file-item" key={file.id}
                           onClick={() => downloadAPIFile(
                               `project_attached_files/${file.id}/download`,
                               file.name
                           )}>{file.name}</a>
                    ))}
                </div>

                <DropZone
                    uploadEndpoint={'project_attached_files'}
                    createRequestBody={createRequestBody}
                    onFileUploaded={onFileUploaded}
                    onFileNotUploaded={onFileNotUploaded}
                    containerData={project}
                />
            </div>
        </>
    )

}